import { isTimeSlotEqual, TimeSlot } from '../domain/TimeSlot';

export function areTimeSlotsEqual(slots1: TimeSlot[], slots2: TimeSlot[]): boolean {
    if (slots1.length !== slots2.length) {
        return false;
    }

    if (slots1.length === 0) {
        return true;
    }

    for (let i = 0; i < slots1.length; i++) {
        if (!isTimeSlotEqual(slots1[i], slots2[i])) {
            return false;
        }
    }

    return true;
}


